export const DEFAULT_FILTER = "Default"
export const DISTANCE_FILTER = "Distance"
export const YEARS_CERTIFIED_FILTER = "YearsAceCertified"
export const FINDACEPRO_BASE_URL = "/api/FindACEProByName/";
export const RESULTS_PAGE_URL = "/resources/everyone/find-ace-pro/results/";
